<style></style>

<template>
    <primary-block>
        <template #step>
          <span class="five-steps-number one float-left"></span>
          <h3 class="lighter text-orange">
            ASSESS
          </h3>
          <p>Take a self-assessment to find areas for improvement</p>
        </template>
        <template #action>
          <!-- Not Started -->
          <div v-if="assessments.length === 0">
            <p>Status: <strong>Not Started</strong></p>
            <a :href="$basePath+'/self-assessments/intro/'+module.slug" class="btn btn-orange-blue" v-if="isProgramUser">Start Self-Assessment</a>
          </div>

          <div v-if="assessments.length > 0">
            <!-- In Progress -->
            <div v-if="lastAssessment.status === 'In Progress' || lastAssessment.status === 'Not Started'">
              <p>Status: <strong>In Progress</strong></p>
              <a :href="$basePath+'/self-assessments/'+module.slug+'/'+lastAssessment.id+'/summary'" class="btn btn-orange-blue assess-btn" v-if="isProgramUser">Finish Self-Assessment</a>
            </div>

            <!-- Completed -->
            <div v-if="lastAssessment.status === 'Completed'">
              <p>Status: <strong>Completed {{ formatDate }}</strong></p>
              <div class="assess-btn">
                <a :href="$basePath+'/self-assessments/'+module.slug+'/'+lastAssessment.id+'/results'" class="btn btn-orange-blue" v-if="isProgramUser">View Results</a>
              </div>
              <div class="assess-btn mt-1">
                <a :href="$basePath+'/self-assessments/intro/'+module.slug" class="btn btn-orange-blue" v-if="isProgramUser">Start New Assessment</a>
              </div>
              <assessment-dropdown :assessments="assessments" :module="module" v-if="!isProgramUser" class="mt-3"></assessment-dropdown>
            </div>
          </div>
        </template>
    </primary-block>
</template>

<script>
    import PrimaryBlock from '../dashboard_tabs/PrimaryBlock'
    import moment from 'moment'
    import Auth from '../../auth'
    import AssessmentDropdown from '../AssessmentDropdown'

    export default {
        components: {
            PrimaryBlock, 
            AssessmentDropdown
        },
        props: {
            module: {
                required: true,
                type: Object
            },
            assessments: {
                required: true,
                type: Array
            }
        },
        data() {
            return {}
        },
        computed: {
            lastAssessment: function () {
                return this.assessments[this.assessments.length-1]
            },
            isProgramUser: function (){
                return Auth.is('program-user')
            },
            // $basePath() {
            //   return window.basePath;
            // },
            formatDate: function () {
                if (this.lastAssessment) {
                    return moment(String(this.lastAssessment.finalized_at)).format('MM/DD/YY')
                }
            },
        }
    }
</script>